export default "__VITE_ASSET__$ftlzrK2__"